
import { Recipe, RecipeCategory, RecipeIngredientResponse, PaginatedRecipeResponse } from "@/types/recipe";

export const mockPaginatedRecipeResponse: PaginatedRecipeResponse = {
  recipes: [
    {
      id: 82890,
      name: "Biscotti",
      description: "",
      price: 6,
      cost: 2.50,
      beneficio: 3.50,
      margen: 0.58,
      creation_date: "2024-11-27 19:05:14.299320",
      last_update: "2025-02-07 04:00:09.420124",
      active: 1,
      for_sale: 1,
      businessUnit_id: 20,
      prep_time: "45m",
      profit_margin: 38,
      preparationSteps: [],
      history: [
        {
          date: "2024-03-15",
          cost: "$2.50",
          margin: "35%",
          ingredients: 8
        },
        {
          date: "2024-02-01",
          cost: "$2.25",
          margin: "32%",
          ingredients: 7
        },
        {
          date: "2024-01-15",
          cost: "$2.75",
          margin: "30%",
          ingredients: 8
        }
      ],
      ingredients: [
        {
          id: "1",
          name: "Flour",
          quantity: "250",
          unit: "g",
          cost: "0.30"
        },
        {
          id: "2",
          name: "Sugar",
          quantity: "150",
          unit: "g",
          cost: "0.25"
        },
        {
          id: "3",
          name: "Eggs",
          quantity: "2",
          unit: "unit",
          cost: "0.60"
        },
        {
          id: "4",
          name: "Butter",
          quantity: "100",
          unit: "g",
          cost: "0.75"
        },
        {
          id: "5",
          name: "Almonds",
          quantity: "75",
          unit: "g",
          cost: "0.60"
        }
      ]
    },
    {
      id: 82891,
      name: "Bizcochon halloween",
      description: "",
      price: 16,
      cost: 5.60,
      beneficio: 10.40,
      margen: 0.65,
      creation_date: "2024-11-27 19:05:14.589957",
      last_update: "2024-11-28 08:23:27.736751",
      active: 1,
      for_sale: 1,
      businessUnit_id: 20,
      prep_time: "60m",
      profit_margin: 65,
      preparationSteps: [],
      history: [
        {
          date: "2024-03-20",
          cost: "$5.60",
          margin: "65%",
          ingredients: 12
        },
        {
          date: "2024-02-05",
          cost: "$5.25",
          margin: "60%",
          ingredients: 11
        }
      ],
      ingredients: [
        {
          id: "1",
          name: "Flour",
          quantity: "500",
          unit: "g",
          cost: "0.60"
        },
        {
          id: "2",
          name: "Sugar",
          quantity: "300",
          unit: "g",
          cost: "0.50"
        },
        {
          id: "3",
          name: "Eggs",
          quantity: "4",
          unit: "unit",
          cost: "1.20"
        },
        {
          id: "4",
          name: "Butter",
          quantity: "250",
          unit: "g",
          cost: "1.85"
        },
        {
          id: "5",
          name: "Chocolate",
          quantity: "150",
          unit: "g",
          cost: "1.45"
        }
      ]
    }
  ],
  pagination: {
    total: 133,
    count: 2,
    page: 1,
    pages: 67,
    limit: 2,
    offset: 0
  }
};

export class MockRecipeService {
  async getRecipes(businessUnitId: number, offset: number = 0, limit: number = 20): Promise<PaginatedRecipeResponse> {
    return mockPaginatedRecipeResponse;
  }

  async getRecipeById(id: string): Promise<Recipe | undefined> {
    return mockPaginatedRecipeResponse.recipes.find(r => r.id === Number(id));
  }

  async getRecipeWithIngredients(recipeId: number, businessUnitId: number): Promise<RecipeIngredientResponse> {
    const recipe = mockPaginatedRecipeResponse.recipes.find(r => r.id === recipeId);
    
    if (!recipe) {
      return {
        business_unit_id: businessUnitId,
        recipes: []
      };
    }
    
    return {
      business_unit_id: businessUnitId,
      recipes: [{
        recipe_id: recipeId,
        recipe_name: recipe.name,
        recipe_description: recipe.description || "",
        ingredients: recipe.ingredients.map(ing => ({
          id: parseInt(ing.id),
          name: ing.name,
          amount: parseFloat(ing.quantity),
          metric: {
            id: 1,
            name: ing.unit
          },
          optional: false,
          cost: parseFloat(ing.cost)
        })),
        preparation_steps: recipe.preparationSteps.map(step => ({
          id: parseInt(step.id),
          instruction: step.instruction
        })),
        cost: recipe.cost,
        price: recipe.price,
        prep_time: recipe.prep_time,
        profit_margin: recipe.profit_margin
      }]
    };
  }

  async getRecipesByCategory(category: RecipeCategory): Promise<Recipe[]> {
    return mockPaginatedRecipeResponse.recipes.filter(recipe => recipe.category === category);
  }

  async searchRecipes(query: string): Promise<{ data: Recipe[] }> {
    const filteredRecipes = mockPaginatedRecipeResponse.recipes.filter(recipe => 
      recipe.name.toLowerCase().includes(query.toLowerCase())
    );
    return { data: filteredRecipes };
  }

  async updateRecipe(recipe: Recipe): Promise<Recipe> {
    return recipe;
  }
}

export const mockRecipeService = new MockRecipeService();
